export function formatCountCopy(n: number): string {
  if (n <= 1000) return '' + n

  const divided = n / 1000
  const fixed = divided.toFixed(1)
  const commaFormat = fixed.replace('.', ',')

  return `${commaFormat}K`
}
